type Props = {
  title: string;
  onClicks: () => void;
  toStatus: boolean;
  isLoadingClickBtn: boolean;
  movilWeb: boolean; //solo pasar un true o false para verificar si va hacer movil o web.
};

const styles = {
  color: "#fff",
};

export const NewBuy2 = ({
  title,
  onClicks,
  toStatus,
  isLoadingClickBtn,
  movilWeb,
}: Props): JSX.Element => {
  const classNamesMovilWeb = `ps-btn develop__buttons ${
    !movilWeb ? "btn__develop__movil" : ""
  }`;

  return (
    <button
      className={`${classNamesMovilWeb} 
        ${isLoadingClickBtn ? "" : "text-white develop___btnLoading"}
        `}
      disabled={isLoadingClickBtn}
      onClick={onClicks}
      style={styles}>
      {toStatus ? (
        <>
          <span
            className="spinner-border spinner-border-md"
            role="status"
            aria-hidden="true"></span>
          <span className="ml-4">Procesando ...</span>
        </>
      ) : (
        title
      )}
    </button>
  );
};
